
import {LoadCsvRowsModalState,  SaleEditState } from "@/utils/sale-edit/sale-edit-state";
import Vue from "vue";
import AppFileUpload from "@/components/FileUploadDropAndProgress.vue";
import { allowedColsAsList, ICsvToSaleRowsOptions } from "@/utils/sale-edit/csv-to-sale-rows";

export default Vue.extend({
	data(){
		return {
			file: null as null | File,
			options: {
				useCommaAsDeciamlSeperator: false
			} as ICsvToSaleRowsOptions
		};
	},
	props: {
		state: {
			type: Object as ()=>SaleEditState,
			required: true
		}
	},
	computed: {
		isOpen():boolean {
			return this.state.csvRowsModalState != LoadCsvRowsModalState.CLOSED;
		},
		page():number {
			return this.state.csvRowsModalState;
		},
		allowedExtensions():string[]{
			return ["csv", "txt"];
		},
		allowedFields():string{
			return allowedColsAsList().join(";");
		}
	},
	watch: {
		isOpen(){
			this.file = null;
		}
	},
	methods: {
		close(){
			this.state.csvRowsModalState = LoadCsvRowsModalState.CLOSED;
		},
		confirm(){
			if (!this.file) return;
			this.state.uploadCsvRows(this.file, this.options);
			localStorage.setItem("csv-to-sale-rows-saved-options", JSON.stringify(this.options));
		}
	},
	created(){
		this.options = JSON.parse(localStorage.getItem("csv-to-sale-rows-saved-options") || "{}");
	},
	components: {
		AppFileUpload
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
